export const MANTRA_DAY_TIME = [
  { value: 'Twilight', label: 'Twilight' },
  { value: 'Morning', label: 'Morning' },
  { value: 'Afternoon', label: 'Afternoon' },
  { value: 'Evening', label: 'Evening' }
]

export const MONTHS = [
  { value: 'Chet', label: 'Chet' },
  { value: 'Vaisakh', label: 'Vaisakh' },
  { value: 'Jeth', label: 'Jeth' },
  { value: 'Sawan', label: 'Sawan' },
  { value: 'Bhadon', label: 'Bhadon' },
  { value: 'Kattak', label: 'Kattak' },
  { value: 'Maghar', label: 'Maghar' },
  { value: 'Poh', label: 'Poh' },
  { value: 'Magh', label: 'Magh' },
  { value: 'Phaggan', label: 'Phaggan' }
]

export const GUIDE_TUTORIAL_MODULES = [
  { value: 'ragi-schedule', label: 'Ragi Schedule' },
  { value: 'katha-schedule', label: 'Katha Schedule' },
  { value: 'daily-routines', label: 'Daily Routines' },
  { value: 'contact-us', label: 'Contact Us' },
  { value: 'gurudwara-details', label: 'Gurudwara Details' },
  { value: 'sarai-details', label: 'Sarai Details' },
  { value: 'faqs', label: 'FAQs' },
  { value: 'gurudwara-thumbnail', label: 'Gurudwara Thumbnail' },
  { value: 'organization-thumbnail', label: 'Organization Thumbnail' },
  { value: 'gurudwara-service', label: 'Gurudwara Service' },
  { value: 'gurudwara-tabs', label: 'Gurudwara Tabs' },
]

export const ORG_GUIDE_TUTORIAL_MODULES = [
  { value: 'contact-us', label: 'Contact Us' },
  { value: 'organization-details', label: 'Organization Details' },
  { value: 'faqs', label: 'FAQs' },
  { value: 'organization-tabs', label: 'Organization Tabs' },
  { value: 'organization-thumbnail', label: 'Organization Thumbnail' },
  { value: 'organization-service', label: 'Organization Service' }
]


export const GURUDWARA_MAX_IMAGES_COUNT = 20

export const GURUDWARA_MAX_VIDEOS_COUNT = 20

export const MAX_IMAGE_SIZE = 1024 * 1024 // Maximum image size (1 MB)

export const MAX_VIDEO_DURATION = 60 // Maximum video duration (60 seconds)
